import React, { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'

import styles from '../component-styles/forgot-password.module.scss'
import Carousel from '../components/carousel'
import Form from '../components/forgot-password-form'
import Result from '../components/forgot-password-result'
import { resetForgotPassword } from '../store/actions'
import Footer from '../components/footer'

export default function ForgotPassword(): React.ReactElement {
  const forgot = useSelector((state: any): any => state.support.forgotPassword)
  const dispatch = useDispatch()
  useEffect((): void => {
    dispatch(resetForgotPassword())
  }, [dispatch])

  return (
    <div className={styles.ssoWrapperOuter}>
      <section className={styles.ssoWrapper}>
        <Carousel
          width={460}
          style={{ height: 538 }}
          history={{}}
          currentProgress={forgot.requested ? 1 : 0}
          items={[
            {
              key: 1,
              component: (props: any): React.ReactElement => (
                <Form {...props} />
              ),
            },
            {
              key: 2,
              component: (props: any): React.ReactElement => (
                <Result {...props} />
              ),
            },
          ]}
        />
      </section>
      <Footer />
    </div>
  )
}
